import { createNextTableContext } from '@core/table';

export const CustomsPostsTableContext = createNextTableContext();
